"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var QuestionAndAnswerReplaceQuestionModal = function QuestionAndAnswerReplaceQuestionModal(_ref) {
  var closeOverrideModal = _ref.closeOverrideModal,
      handleSave = _ref.handleSave;
  return _react.default.createElement(_UIModal.default, {
    use: "danger"
  }, _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_UIDialogCloseButton.default, {
    onClick: closeOverrideModal
  }), _react.default.createElement(_H.default, null, _react.default.createElement(_FormattedMessage.default, {
    message: "composer-plugins.questionAndAnswer.replaceQuestionModal.title"
  }))), _react.default.createElement(_UIDialogBody.default, null, _react.default.createElement(_FormattedMessage.default, {
    message: "composer-plugins.questionAndAnswer.replaceQuestionModal.body"
  })), _react.default.createElement(_UIDialogFooter.default, null, _react.default.createElement(_UIButton.default, {
    use: "danger",
    onClick: function onClick() {
      handleSave({
        createNew: true
      });
      closeOverrideModal();
    }
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "composer-plugins.questionAndAnswer.replaceQuestionModal.saveAndReplace"
  })), _react.default.createElement(_UIButton.default, {
    use: "tertiary-light",
    onClick: closeOverrideModal
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "composer-plugins.questionAndAnswer.replaceQuestionModal.cancel"
  }))));
};

QuestionAndAnswerReplaceQuestionModal.propTypes = {
  closeOverrideModal: _propTypes.default.func.isRequired,
  handleSave: _propTypes.default.func.isRequired
};
var _default = QuestionAndAnswerReplaceQuestionModal;
exports.default = _default;
module.exports = exports.default;